import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CaseData {
  caseId: string;
  claimNumber: string;
  dateOfRegistration: string;
  dateOfIncident: string;
  isRushCase: boolean;
  additionalNotes: string;
}

interface CaseState {
  cases: CaseData[];
}

const initialState: CaseState = {
  cases: [],
};

const caseSlice = createSlice({
  name: 'cases',
  initialState,
  reducers: {
    addCase(state, action: PayloadAction<CaseData>) {
      state.cases.push(action.payload);
    },
    updateCase(state, action: PayloadAction<CaseData>) {
      const index = state.cases.findIndex(
        (caseItem) => caseItem.caseId === action.payload.caseId
      );
      if (index !== -1) {
        state.cases[index] = action.payload;
      }
    },
    // Set fetched items
    setCaseItems: (state, action) => {
      state.cases = action.payload; 
    },
  },
});

export const { addCase, updateCase, setCaseItems } = caseSlice.actions;
export default caseSlice.reducer;
